import TituloGenerico from '@/components/atoms/TituloGenerico';
import { TituloRetornoBusca } from '@/services/types/titulo';
import * as S from './styles';
import useBreakpoint from '@/hooks/useBreakpoint';
import { TamanhosCartaz } from '@/components/atoms/Cartaz';
import { registrarEvento } from '@/services/googleAnalytics';

interface ListagemConteudosProps {
  $conteudos: TituloRetornoBusca[] | undefined | null;
  $busca?: string;
}

export default function ListagemConteudos(props: ListagemConteudosProps) {
  const { $conteudos, $busca } = props;
  const { widthWindow } = useBreakpoint();

  if (!$conteudos || !$conteudos.length) return null;

  const notaEstrelaTitulo = (
    conteudo: TituloRetornoBusca,
  ): number | undefined => {
    return 'nota' in conteudo ? Number(conteudo.nota) : undefined;
  };

  const notaChippuTitulo = (
    conteudo: TituloRetornoBusca,
  ): number | undefined => {
    return 'nota' in conteudo ? Number(conteudo.nota) : undefined;
  };

  const tamanhoCartaz: TamanhosCartaz =
    widthWindow >= 365 ? 'medio' : 'pequeno';

  function cliqueResultado(nomeFicha: string) {
    if ($busca === '' || $busca == null) return;

    registrarEvento('clique_resultado_busca', {
      busca: $busca,
      ficha: nomeFicha,
    });
  }

  return (
    <S.Container $tamanhoCartaz={tamanhoCartaz}>
      {$conteudos?.map((conteudo) => {
        const imagemTitulo =
          conteudo.posterArquivo?.urlx3 ||
          conteudo.posterArquivo?.urlx2 ||
          conteudo.posterArquivo?.urlx1;

        return (
          <TituloGenerico
            key={conteudo.tituloID}
            $image={imagemTitulo}
            $nome={conteudo.titulo}
            $notaEstrela={notaEstrelaTitulo(conteudo)}
            $notaChippu={notaChippuTitulo(conteudo)}
            $link={`/ficha/${conteudo?.slug}`}
            $tamanhoCartaz={tamanhoCartaz}
            $eventoAnalytics={() => cliqueResultado(conteudo.titulo)}
          />
        );
      })}
    </S.Container>
  );
}
